import React, { Component, useState, useEffect } from 'react';
import * as ReactDOM from 'react-dom';
import Configdata from './Defaultdata';
import Usersession from './Usersession';
import usrf1 from './imgs/grlpfp.png';
import usrm1 from './imgs/boypfp.png';
import sofa from './Homeitems/sofa.png';
import sofa1 from './Homeitems/sofa1.gif';
import pack from './Homeitems/packs.gif';
import homedecore from './Homeitems/hsdecor.jpg';
import car from './Homeitems/car.gif';
import bike from './Homeitems/bike.png';
import dimondring from './Homeitems/dimonring.gif';
import heart from './Homeitems/heart.gif';
import heel from './Homeitems/heel.png';
import dimond from './Homeitems/dimond.gif';

import {stcolor} from './userdefaultdata';
import {showhidediv,loadwidgate,clrwidgate,setdvl,configchat,getsid,insertpost,setbkc,hopitems,gets} from './userdefaultdata';
import { getmessage } from './Dynamictable';
import {isvaluenull} from './validation';
import {GetItemslist} from './Itemslist';

export default class Shoping extends Component {

    constructor(props: any) {
   	super(props);
	this.state.name = "profilepic";
	
  	}
	
    state = {

	
        name: "",
       respdata: null,   
       url: "",
      pfp:usrf1,
      uset:{pfpid:0,age:0,utf:true,uname:'',points:0},
      isf:true,
      uage:0,
      pnt:0,
      ismsgshow:true,
      ishidesetiing:false,
      vtid:1,
      
      items:[{mitemname: "",mitemurl: "",mextention: "",mitemtype: 0,msts: 0,mpointdeduct: 0}],
    };
    setserverurl() {
        debugger;
        const appurl = Configdata.srvurl;
       
        this.setState({ url: appurl });
    }
    setcolor(e:any) {
        debugger;
        //const ccb = document.getElementById('colorpicker') as HTMLInputElement;
       // ccb.click();
        
    }
    handleColorChange = (event:any) => {
     const colr = event.target.value;
     stcolor(colr);
     //const ccb = document.getElementById('colorpicker') as HTMLInputElement;
     //ccb.style.display='none';
       
    }
  togglesetting(){
       const id = 'usersetdiv';
	const ishide = !this.state.ishidesetiing;
        showhidediv(ishide,id);
          this.setState({ ishidesetiing: ishide });

  }
   setmessage(e:any) {
        //debugger;
        const mgsshow = !this.state.ismsgshow; 
        showhidediv(mgsshow,'wgtmsg');
         this.setState({ ismsgshow: mgsshow });

    }
    addfunds(e:any) {
        //debugger;
       // const subuser = <Createsubuser />; 
        //showhidediv(mgsshow,'wgtmsg');
        // this.setState({ ismsgshow: mgsshow });
        // showhidediv(true,'chatprofiledivtop');

	//loadwidgate('wigtarea',9);
    }
   setbackcolorvt(){
	setbkc('vmoderate','blue');
	setbkc('vtradition','blue');
	setbkc('vluxurious','blue');

  }
setvtid(e:any){
	const eid = e.target.id;
         this.setbackcolorvt();
	e.target.style.backgroundColor = 'green';
	
	if(eid == "vmoderate") this.setState({ vtid: 1 });
	else if(eid == "vtradition") this.setState({ vtid: 2 });
	else if(eid == "vluxurious") this.setState({ vtid: 3 });

	

  }
isvalidatedctrls(){
	let isvalidate = true;
	
	if(isvaluenull(this.state.name)){
	  getmessage('villa Name should not Blanck','');
	  return false;
	}
	 else if(this.state.name.length < 4 || this.state.name.length > 14){
	  getmessage('villa name within 4 to 14 alphanumeric','');
	  return false;
	}

        
	return isvalidate;	
    }	

Purchasevilla(e:any,id:any,tp:any,points:any) {
    const vnm = this.state.name;
    const vt = this.state.vtid;
    const unm = Usersession.getUsername();
     const uid = Usersession.getUserId();
      const pin = Usersession.getUserpin();
     const sid = gets('Superuserid');
     //alert(uid);
    if(this.isvalidatedctrls()){
		const url = '/insertpvtvlla';
    const data = {adminid:sid,upin:pin,uname:unm,points:20,
		suid:uid,vname:vnm,vllatp:vt
		,itemid:id
		};
	insertpost(url,data);
    }
   
    }

  Purchaseitm(e:any,id:any,tp:any,points:any) {
    const unm = Usersession.getUsername();
     const uid = Usersession.getUserId();
      const pin = Usersession.getUserpin();
     const sid = gets('Superuserid');
    const giftuserid =  Usersession.getIsgifted();
    const giftingid = giftuserid > 0 ? giftuserid:0;
 //  alert(isgifted);
    const isgifted = giftuserid > 0 ? 1:0;
     const url = '/insertsaleitem';

    const data = {adminid:sid,upin:pin,uname:unm,
		userid:uid,itemid:id,itmtypid:tp
		,pointrs:points,isgift:isgifted,giftedid:giftingid
		};
     if(pin){if(sid){
      insertpost(url,data);
      }}
    
    }
    stvln(e:any){
	 const ccb = e.target.value;   
     	//const vn = ccb.value; 
	this.setState({ name: ccb });

    }
    componentDidMount() {
        debugger;
        
	this.setpfp();
        this.togglesetting();
	this.setbackcolorvt();
	setbkc('vmoderate','green');
         

        //this.setspitems();
    }
 
setpfp(){
        
         const upf = Usersession.getUserpfp();
         const pfpcode = upf.pfpid;
         const ut = upf.utf; 
         const ag = upf.age;
         const un = upf.uname;
	const point = upf.points;

           this.setState({ name: un });
   	this.setState({ pnt: point });

         this.setState({ uage: ag });
         if(pfpcode == 0)this.setState({ pfp: usrf1 });
	 else if(pfpcode == 1)this.setState({ pfp: usrm1 });
         
	if(ut)this.setState({ isf: true });
	 else this.setState({ isf: false });

	 

}
setspitems(){
 hopitems(1,1);         

}

settingprofile(e:any){
  this.togglesetting();
}    
 render() {

   
     return (
     <div style={{height:'90vh'}} className="c-pfp-line">

       <div style={{height:'12vh'}} >
	<div style={{height:'auto',width:'100%'}}>  
 	    <div style={{height:'40px'}} className="search-title-bar">
                 <a href="#" className="blanka"  onClick={e=>this.setmessage(e)} title="Message setting" > 
			<div id="purchaseitembar" style={{top:'3px',float:'left',width:'64%',textAlign:'center'}} className="c-usr-profile">

		  	   Purchase 

             		</div>
	    </a>
	   <a href="#" className="blanka"  onClick={e=>this.addfunds(e)} title="Add funds">
                       <div id="usercreate" style={{top:'3px',float:'right'}} className="c-usr-profile">

			 
				 Add Points
			  
			
			</div>
              </a>		    
           
	    </div>
           <div style={{maxHeight:'86vh',overflowY:'auto',overflowX:'hidden'}}>
            <div style={{height:'75px'}} className="purchase-itm-nm">
		

		<div id="purchasevilla" className="p-usr-itm-nm">
 		
	       <div style={{height:'30%'}} className="per100">  
  <input placeholder="Enter villa Name" onKeyUp={e=>this.stvln(e)} id="txtvname" type="text" style={{width:'95%',height:'25px'}}/>

		</div>
		
                <div style={{height:'50%',paddingLeft:'7%',paddingTop:'1.5%'}} className="per100"> 
              <a href="#" className="blanka"  onClick={e=>this.setvtid(e)} title="New user">    
			<span className="p-usr-itm-subnm" id="vmoderate">Moden</span>
		</a>
	         <a href="#" className="blanka"  onClick={e=>this.setvtid(e)} title="New user">
			<span className="p-usr-itm-subnm" id="vtradition">village</span>
		</a>
		<a href="#" className="blanka"  onClick={e=>this.setvtid(e)} title="New user">
			<span className="p-usr-itm-subnm" id="vluxurious">Luxuri</span>
		</a>

		</div>

             	</div>
	<a href="#" className="blanka"  onClick={e=>this.Purchasevilla(e,1,0,20)} title="20 points">
		<div id="purchasevilla" className="p-usr-itm-cst">

		  	   20 points

             	</div>
	     </a>
	    </div>

<div style={{height:'75px'}} className="purchase-itm-nm">
		

		<div id="dvcar" style={{height:'auto'}} className="p-usr-itm-nm">
 		
	          <div className="per100">  
  		  
			<img style={{width:'20vw'}} src={car} className="c-pfp-img" />

		  </div>
		               

             	</div>
	<a href="#" className="blanka"  onClick={e=>this.Purchaseitm(e,2,1,12)} title="12 points">
		<div id="car" style={{height:'75px'}}  className="p-usr-itm-cst">

		  	   12 points 

             	</div>
	     </a>
	    </div>
<div style={{height:'75px'}} className="purchase-itm-nm">
		

		<div id="dvbike" style={{height:'auto'}} className="p-usr-itm-nm">
 		
	          <div className="per100">  
  		  
			<img style={{width:'20vw'}} src={bike} className="c-pfp-img" />

		  </div>
		               

             	</div>
	<a href="#" className="blanka"  onClick={e=>this.Purchaseitm(e,3,1,12)} title="12 points">
		<div id="bike" style={{height:'75px'}}  className="p-usr-itm-cst">

		  	   12 points 

             	</div>
	     </a>
	    </div>


<div style={{height:'75px'}} className="purchase-itm-nm">
		

		<div id="dvsofa" style={{height:'auto'}} className="p-usr-itm-nm">
 		
	          <div className="per100">  
  		  
			<img style={{width:'20vw'}} src={sofa} className="c-pfp-img" />

		  </div>
		               

             	</div>
	<a href="#" className="blanka"  onClick={e=>this.Purchaseitm(e,4,1,12)} title="12 points">
		<div id="pursofa" style={{height:'75px'}}  className="p-usr-itm-cst">

		  	   12 points 

             	</div>
	     </a>
	    </div>

<div style={{height:'75px'}} className="purchase-itm-nm">
		

		<div id="sofa" style={{height:'auto'}} className="p-usr-itm-nm">
 		
	          <div className="per100">  
  		  
			<img style={{width:'20vw'}} src={sofa1} className="c-pfp-img" />

		  </div>
		               

             	</div>
	<a href="#" className="blanka"  onClick={e=>this.Purchaseitm(e,5,1,6)} title="12 points">
		<div id="purchasering" style={{height:'75px'}}  className="p-usr-itm-cst">

		  	   12 points 

             	</div>
	     </a>
	    </div>

<div style={{height:'75px'}} className="purchase-itm-nm">
		

		<div id="dvpack" style={{height:'auto'}} className="p-usr-itm-nm">
 		
	          <div className="per100">  
  		  
			<img style={{width:'20vw'}} src={pack} className="c-pfp-img" />

		  </div>
		               

             	</div>
	<a href="#" className="blanka"  onClick={e=>this.Purchaseitm(e,6,1,12)} title="12 points">
		<div id="packpoint" style={{height:'75px'}}  className="p-usr-itm-cst">

		  	   12 points 

             	</div>
	     </a>
	    </div>

<div style={{height:'75px'}} className="purchase-itm-nm">
		

		<div id="dvhmdcr" style={{height:'auto'}} className="p-usr-itm-nm">
 		
	          <div className="per100">  
  		  
			<img style={{width:'20vw'}} src={homedecore} className="c-pfp-img" />



		  </div>
		               

             	</div>
	<a href="#" className="blanka"  onClick={e=>this.Purchaseitm(e,7,1,12)} title="12 points">
		<div id="homdcr" style={{height:'75px'}}  className="p-usr-itm-cst">

		  	   12 points 

             	</div>
	     </a>
	    </div>
<div style={{height:'75px'}} className="purchase-itm-nm">
		

		<div id="dvdmmndrng" style={{height:'auto'}} className="p-usr-itm-nm">
 		
	          <div className="per100">  
  		  
			
		<img style={{width:'20vw'}} src={dimondring} className="c-pfp-img" />



		  </div>
		               

             	</div>
	<a href="#" className="blanka"  onClick={e=>this.Purchaseitm(e,8,1,12)} title="12 points">
		<div id="dimondring" style={{height:'75px'}}  className="p-usr-itm-cst">

		  	   12 points 

             	</div>
	     </a>
	    </div>
        

     <div style={{height:'75px'}} className="purchase-itm-nm">
		

		<div id="dvhart" style={{height:'auto'}} className="p-usr-itm-nm">
 		
	          <div className="per100">  
  		  
			<img style={{width:'10vw'}} src={heart} className="c-pfp-img" />



		  </div>
		               

             	</div>
	<a href="#" className="blanka"  onClick={e=>this.Purchaseitm(e,9,1,12)} title="12 points">
		<div id="hartpoint" style={{height:'75px'}}  className="p-usr-itm-cst">

		  	   12 points 

             	</div>
	     </a>
	    </div>


  <div style={{height:'75px'}} className="purchase-itm-nm">
		

		<div id="dvheel" style={{height:'auto'}} className="p-usr-itm-nm">
 		
	          <div className="per100">  
  		  
			<img style={{width:'10vw'}} src={heel} className="c-pfp-img" />



		  </div>
		               

             	</div>
	<a href="#" className="blanka"  onClick={e=>this.Purchaseitm(e,10,1,12)} title="12 points">
		<div id="heelpoint" style={{height:'75px'}}  className="p-usr-itm-cst">

		  	   12 points 

             	</div>
	     </a>
	    </div>


<div style={{height:'75px'}} className="purchase-itm-nm">
		

		<div id="dvheel" style={{height:'auto'}} className="p-usr-itm-nm">
 		
	          <div className="per100">  
  		  
			<img style={{width:'10vw'}} src={dimond} className="c-pfp-img" />



		  </div>
		               

             	</div>
	<a href="#" className="blanka"  onClick={e=>this.Purchaseitm(e,11,1,12)} title="12 points">
		<div id="heelpoint" style={{height:'75px'}}  className="p-usr-itm-cst">

		  	   12 points 

             	</div>
	     </a>
	    </div>



	 <div style={{display:'none',position:'relative'}} id="ushopitems" className="shopitems">  
	 test
	</div>	
        </div> 


	</div> 

	</div>

	
  
   </div>
   
   
      );
}
}

